const MONTH_YEARLY_INDICES = [ 'ndvi' ];

const GEOSPATIAL_OPTIONS_BY_EII_DETAIL = {
  composition: [
    { label: 'Riqueza', value: 'richness' },
  ],
  struct: [
    { label: 'Parches', value: 'patches' },
    { label: 'Parches de bosque', value: 'forest-patches' },
    { label: 'Parches de humedal', value: 'wetland-patches' },
    { label: 'Parches de matorral', value: 'shrubland-patches' },
    { label: 'Parches de pastizal', value: 'grassland-patches' },
    { label: 'Parches de nieve y glaciar', value: 'snow-patches' },
  ],
  function: [
    { label: 'Productividad Primaria Bruta', value: 'gpp' },
    { label: 'Biomasa', value: 'biomass' },
  ],
};

// Opciones para el detalle de EII (Composición, Estructura, Función)
const eiiDetailOptions = [
  { label: 'Composición', value: 'composition' },
  { label: 'Estructura', value: 'struct' },
  { label: 'Función', value: 'function' },
];

const getEiiDetailOptions = options => {
  if (!options) {
    return [];
  }
  return eiiDetailOptions.map(({ value, label }) => {
    const detail = options[value];
    if (detail?.length) {
      return { label, value };
    }
  }).filter(f => f);
};

const legendTitle = {
  biomass: 'CO2eq (ton/ha)',
  'conversion-areas': 'Cambio de uso de suelo - Antrópico',
  'eii-reclass': 'Clases de condición',
};

const getMinMaxValues = (leftAsset, rightAsset) => {
  const minValues = [ leftAsset.minValue, rightAsset.minValue ].filter(v => v);
  const minValue = minValues.length > 0 ? Math.min(...minValues) : -1;
  const maxValues = [ leftAsset.maxValue, rightAsset.maxValue ].filter(v => v);
  const maxValue = maxValues.length > 0 ? Math.max(...maxValues) : 1;
  return [ minValue, maxValue ];
};

const groupAssetsByType = assets => assets.reduce((acc, asset) => {
  const typeId = asset.geoInfoTypeId || 'default';
  if (!acc[typeId]) {
    acc[typeId] = [];
  }
  acc[typeId].push(asset);
  return acc;
}, {});

const isYearlyMode = geoInfoTypeId => !MONTH_YEARLY_INDICES.includes(geoInfoTypeId);

const selectDefaultAssets = (assets, geoInfoTypeId, currentSelection = {}) => {
  if (!assets || assets.length === 0) {
    return { leftAsset: null, rightAsset: null };
  }

  const isCurrentTypeYearly = isYearlyMode(geoInfoTypeId);

  const sortedAssets = [ ...assets ].sort((a, b) => {
    if (a.year !== b.year) {
      return a.year - b.year; // Ascendente por año
    }
    return (a.month || 0) - (b.month || 0); // Ascendente por mes
  });

  const currentLeft = currentSelection.leftAsset;
  const currentRight = currentSelection.rightAsset;

  if (currentLeft && currentRight && isCurrentTypeYearly) {
    const leftMatch = sortedAssets.find(a => a.year === currentLeft.year);
    const rightMatch = sortedAssets.find(a => a.year === currentRight.year);

    if (leftMatch && rightMatch) {
      return { leftAsset: leftMatch, rightAsset: rightMatch };
    }
  }

  if (isCurrentTypeYearly) {
    const leftAsset = sortedAssets[0];
    const rightAsset = sortedAssets[sortedAssets.length - 1];
    return { leftAsset, rightAsset };
  } else {
    const reverseSorted = [ ...sortedAssets ].reverse();
    const leftAsset = reverseSorted[0];
    const rightAsset = reverseSorted[1] || reverseSorted[0];
    return { leftAsset, rightAsset };
  }
};

const buildAssetDate = (asset, isYearly) => {
  if (!asset?.year) {
    return null;
  }

  if (isYearly) {
    return new Date(asset.year, 0, 1).toISOString();
  } else {
    return asset.month
      ? new Date(asset.year, asset.month - 1, 1).toISOString()
      : null;
  }
};

const findEiiDetailOptionByGeoInfoTypeId = (geoInfoTypeId, eiiDetailOptions) => {
  for (const [ eiiDetailKey, geoOptions ] of Object.entries(GEOSPATIAL_OPTIONS_BY_EII_DETAIL)) {
    if (geoOptions.some(option => option.value === geoInfoTypeId)) {
      return eiiDetailOptions.find(option => option.value === eiiDetailKey);
    }
  }
  return null;
};


export {
  MONTH_YEARLY_INDICES,
  GEOSPATIAL_OPTIONS_BY_EII_DETAIL,
  legendTitle,
  getMinMaxValues,
  groupAssetsByType,
  isYearlyMode,
  selectDefaultAssets,
  buildAssetDate,
  findEiiDetailOptionByGeoInfoTypeId,
  getEiiDetailOptions,
};
